import ContactService from '@/services/ContactService'

const createContactsModule = () => ({
  namespaced: true,
  state: {
    page: 1,
    pages: 1,
    pageSize: 15,
    total: 0,
    contacts: []
  },
  actions: {
    getContacts: ({ commit, state }) => {
      ContactService.getContacts(state.pageSize, state.page)
        .then((data) => {
          commit('SET_CONTACTS', { contacts: data.contacts })
          commit('SET_PAGES', { pages: data.pages })
          commit('SET_TOTAL', { total: data.total })
        })
        .catch((err) => {
          console.info(err)
        })
    },
    setPage: ({ dispatch, state }, page) => {
      state.page = page
      dispatch('getContacts')
    }
  },
  getters: {
    prevDisabled: (state) => state.page === 1,
    nextDisabled(state) {
      return state.pageSize * state.page >= state.total
    }
  },
  mutations: {
    SET_CONTACTS: (state, { contacts }) => {
      state.contacts = contacts
    },
    SET_PAGES: (state, { pages }) => {
      state.pages = pages
    },
    SET_TOTAL: (state, { total }) => {
      state.total = total
    }
  }
})

export default createContactsModule
